import { Loader2, Tags } from "lucide-react";
import { cn } from "@/modern/utils";
import { MANIFEST_GUIDE_TARGETS, guideTargetProps } from "@/react/guides";

type ManifestTagsNavButtonProps = {
  variant: "empty" | "ready" | "generating-tags";
  tagCount: number;
  onOpen: () => void;
};

export function ManifestTagsNavButton({ variant, tagCount, onOpen }: ManifestTagsNavButtonProps) {
  const isGenerating = variant === "generating-tags";

  return (
    <button
      type="button"
      {...guideTargetProps(MANIFEST_GUIDE_TARGETS.tagsBreadcrumb)}
      onClick={onOpen}
      disabled={isGenerating}
      title={isGenerating ? "Tags are being generated" : "View marketing tags"}
      className={cn(
        "inline-flex items-center gap-1 rounded-md border px-2 py-1 text-sm transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40",
        isGenerating
          ? "cursor-wait border-primary/40 bg-primary/10 font-medium text-foreground"
          : "border-border/70 bg-background/80 font-normal text-muted-foreground hover:border-primary/40 hover:bg-primary/5 hover:text-foreground",
      )}
    >
      {isGenerating ? (
        <Loader2 className="h-3 w-3 shrink-0 animate-spin" aria-hidden />
      ) : (
        <Tags className="h-3 w-3 shrink-0" aria-hidden />
      )}
      {isGenerating ? "Generating tags…" : "Tags"}
      {!isGenerating && tagCount > 0 ? (
        <span className="text-xs tabular-nums text-muted-foreground/80">({tagCount})</span>
      ) : null}
    </button>
  );
}
